<template>
	<div id="addAddr">
		<div class="right">
			<el-button type="primary" icon="el-icon-plus" @click="newAdd">增加</el-button>
		</div>
		<div class="table">
			<el-table :data="tableData" style="width: 100%" height='calc(100vh - 300px)'>
				<el-table-column prop="macAddress" label="pos机号">
				</el-table-column>
				<el-table-column label="领取人" prop="name"></el-table-column>
				<el-table-column label="备注" prop="extra"></el-table-column>
				<el-table-column prop="receiveTime" label="领取时间"></el-table-column>
        <el-table-column prop="postcode" label="出单"></el-table-column>
              <el-table-column prop="invoice" label="是否增加发票"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope='scope'>
						<el-button type="text" @click='updataFun(scope.row)'>修改</el-button>
						<el-button type="text" @click='centerDialogVisible1=true;deleteId=scope.row.id'>删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog :title="title" :visible.sync="centerDialogVisible" width="500" center>
			<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
				<el-form-item label="pos机号:" prop="macAddress">
					<el-input v-model="ruleForm.macAddress"></el-input>
				</el-form-item>
				<el-form-item label="领取人账号:" prop="name">
					<el-input v-model.number="ruleForm.name"></el-input>
				</el-form-item>
				<el-form-item label="备注:">
					<el-input v-model="ruleForm.extra"></el-input>
				</el-form-item>
				<el-form-item label="是否提供发票领取：" prop="invoice">
					<!-- <el-input v-model="ruleForm.postcode"></el-input> -->
          <template>
            <el-radio v-model="ruleForm.invoice" label="1">是</el-radio>
            <el-radio v-model="ruleForm.invoice" label="2">否</el-radio>
          </template>
				</el-form-item>

			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible = false;getData()">取 消</el-button>
				<el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="确认删除？" :visible.sync="centerDialogVisible1" width="600px" center>
			<span>删除后不可恢复，是否确认删除？</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="centerDialogVisible1 = false;getData()">取 消</el-button>
				<el-button type="primary" @click="deleteFun">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		listchannelBySetter,
    delchannel,
    addchannel
	} from '@/axios/api.js'
	export default {
		data() {
      
			var macAddress = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入pos机号'));
				} else {
					callback();
				}
			};
			var name = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入领取人账号'));
				} else {
					callback();
				}
			};
			// var extra = (rule, value, callback) => {
			// 	if (value === '') {
			// 		callback(new Error('请输入备注'));
			// 	} else {
			// 		callback();
			// 	}
			// };
			// var contractNo = (rule, value, callback) => {
			// 	if (!value) {
			// 		return callback(new Error('手机号不能为空'));
			// 	}
			// 	if (!Number.isInteger(value)) {
			// 		callback(new Error('请输入数字值'));
			// 	} else {
			// 		callback();
			// 	}
			// };
			return {
        radio:'1',
				tableData: [],
				centerDialogVisible: false,
				centerDialogVisible1: false,
				ruleForm: {
					id: '',
					macAddress: '',
          name: '',
          sourceBy:'1',
					extra: '',
          invoice: '1',
          channelId:""
				},
				rules: {
					macAddress: [{
						validator: macAddress,
						trigger: 'blur'
					}],
					name: [{
						validator: name,
						trigger: 'blur'
          }]
          // ,
					// extra: [{
					// 	validator: extra,
					// 	trigger: 'blur'
          // }]
          // ,
					// invoice: [{
					// 	validator: invoice,
					// 	trigger: 'blur'
          // }
          // ],
				},
				title: '新增pos机',
				deleteId: ''
			}
    },
    		props:[
			'channelId',
		],
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.postData()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			postData() {
        console.log(this.title)
        console.log(this.ruleForm)
        if(this.title != '添加pos机') {
          var date = new Date(this.ruleForm.receiveTime);
          var time1 = date.getTime();
          this.ruleForm.receiveTime = time1
        }else {
          delete this.ruleForm.receiveTime
        }
         
				addchannel(this.ruleForm)
					.then(res => {
            console.log(res,'108006')
            if(res.data.code == '0') {
            this.centerDialogVisible=false;
            this.centerDialogVisible1=false
            this.getData()
            }else {
               this.$message.error(res.data.msg);
           
            }
					
					})
					.catch(err => {
						console.log(err);
					})
			},
			getData() {
        	var data={
					start:0,
          count:500,
          useTo:'100'
				}
				listchannelBySetter(data)
					.then(res => {
            console.log(res);
            this.tableData = res.data.obj
            for(var i = 0; i<	this.tableData.length; i++) {
               if(this.tableData[i].invoice == '1') {
                 this.tableData[i].invoice = '是'
               }else {
                  this.tableData[i].invoice = '否'
               }
               var date = new Date(this.tableData[i].receiveTime);
                var month = date.getMonth() + 1;
                var hours = date.getHours();
                if(hours < 10)
                    hours = "0" + hours;
                var minutes = date.getMinutes();
                if(minutes < 10)
                    minutes = "0" + minutes;
                var time = date.getFullYear() + "-" + month + "-" + date.getDate() +  " " + hours + ":" + minutes;
                this.tableData[i].receiveTime = time
                console.log(time)
            }
             
                        


					})
					.catch(err => {
						console.log(err);
					})
			},
			updataFun(data) {
        console.log(data.invoice)
       
				this.title = '修改pos机';
				data.contractNo = Number(data.contractNo)
        this.ruleForm = data;
         if(this.ruleForm.invoice == '是') {
          this.ruleForm.invoice = '1'
        }else {
           this.ruleForm.invoice = '2'
        }
				this.centerDialogVisible = true;
			},
			newAdd() {
				this.centerDialogVisible = true;
				this.title = '添加pos机';
				this.ruleForm = {
					id: '',
					macAddress: '',
          name: '',
          sourceBy:'1',
					extra: '',
          invoice: '1',
          channelId:localStorage.getItem('channelId'),
          useTo:'100'
        }
        console.log(this.ruleForm)
			},
			deleteFun(){
        console.log(this.deleteId)
				var data={
				    id:this.deleteId
				}
				delchannel(data)
				.then( res => {
				    console.log(res);
						if(res.data.code == 0){
							this.$message({
								type:'success',
								message:'删除成功！'
							})
							this.centerDialogVisible1=false;
							this.getData()
						}
				})
				.catch(err => {
				    console.log(err);
				})
			}
		},
		mounted() {
			this.getData()
		}
	}
</script>

<style scoped>
	.right {
		text-align: right;
	}

	.table {
		margin-top: 20px;
	}

	#addAddr {
		background: white;
		width: 100%;
		height: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/views/card/posAdministration.vue